<template>
  <div class="page" v-cloak>
    <!-- 导航 -->
    <van-nav-bar :border="false" left-arrow fixed title="明细详情" class="user_balance_log_nav_bar" :z-index="9999" :style="'background: #4374FF; color:#FFFFFF;'" id="nav-bar" @click-left="onClickLeft"> </van-nav-bar>

    <div class="text-row-consume" v-if="consumeData.id">
      <div class="header">
        <p class="desc-text">{{consumeData.description}}</p>
        <p class="amount-text"> -￥{{consumeData.amount || 0}}</p>
      </div>

      <div class="item-text">
        <span class="title">订单编号</span>
        <span>{{consumeData.id }}</span>
      </div>

      <div class="item-text" v-if="consumeData.created_time">
        <span class="title">创建时间</span>
        <span>{{consumeData.created_time }}</span>
      </div>
      <div class="item-text" v-if="consumeData.station_name">
        <span class="title">站点名称</span>
        <span>{{consumeData.station_name }}</span>
      </div>
      <div class="item-text" v-if="consumeData.station_address">
        <span class="title">站点地址</span>
        <span>{{consumeData.station_address }}</span>
      </div>
      <div class="item-text" v-if="consumeData.machine_code">
        <span class="title">设备编码</span>
        <span>{{consumeData.machine_code }}</span>
      </div>
      <div class="item-text" v-if="consumeData.machine_name">
        <span class="title">设备名称</span>
        <span>{{consumeData.machine_name }}</span>
      </div>
      <div class="item-text" v-if="consumeData.start_time">
        <span class="title">开始时间</span>
        <span>{{consumeData.start_time }}</span>
      </div>
      <div class="item-text" v-if="consumeData.end_time">
        <span class="title">完成时间</span>
        <span>{{consumeData.end_time }}</span>
      </div>
      <div class="item-text" v-if="consumeData.timePoor">
        <span class="title">累计时长</span>
        <span>{{consumeData.timePoor }}</span>
      </div>

    </div>

    <van-empty v-if="!consumeData.id" image="error" description="请稍后重试！" /> 
    

    <van-button v-if="consumeData.showRepairButton == 1" class="foot-btn" icon="setting-o" size="large" color="#2998FF" block @click="applyRepair">申请报修</van-button>

  </div>
</template>

<script type="text/babel">
export default {
  name: "consume-log-details",
  components: {},
  props: {},
  data() {
    return {
      consumeDetailId: this.$route.query.id,
      consumeData: {
        id: "", //id
        start_time: "", //开始时间
        end_time: "", //结束时间
        timePoor: "", //时长
        amount: "", //金额
        created_time: "", //创建时间
        description: "", //描述
        showRepairButton: "", //1=显示报修按钮
        station_name: "", //站点名称
        station_address: "", //站点地址
        machine_code: "", //设备编码
        machine_name: "", //设备名称
      }, //类型选择
    };
  },
  watch: {},
  created() {},
  mounted() {
    if (!this.isLogin()) return false;
    this.$toast.loading();
    this.getcofig();
  },
  methods: {
    getcofig() {
      let _this = this;
      let data = {
        id: _this.consumeDetailId, //账户变动类型
      };
      _this.$post("/api/consume_detail", data, data).then((res) => {
        console.log(res);
        this.$toast.clear();

        if (res.data.code == 0) {
          console.log(res.data.data);

          var list = res.data.data;
          console.log(list);

          _this.consumeData = res.data.data;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
      applyRepair() {
      let _this = this;
      _this.$router.push({
        name: "apply-repair",
        query: {
          orderId: _this.consumeData.id,
        },
      });
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.user_balance_log_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
}

.cent-btn {
  position: fixed;
  top: 30%;
  left: 0;
  width: 40%;
  z-index: 9;
}

.foot-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9;
}

.text-row-consume {
  width: 100%;
  display: block;
  margin: auto 0;
  // height: 357px;
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #eeeeee;

  .header {
    text-align: center;
    width: 100%;

    .desc-text {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }
    .amount-text {
      font-size: 23px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
    }
  }
  .item-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-top: 23px;

    .title {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }

  .in-text {
    color: #333333;
  }
  .out-text {
    color: #f03535;
  }
}
</style>
 